import React, { useState, useEffect, useRef } from 'react';
import MobileSponsorBanner from './MobileSponsorBanner';
import DesktopSponsorBanner from './DesktopSponsorBanner';
import HeaderAdBanner from './HeaderAdBanner';

const DESKTOP_MIN = 960;

const AdContainer = ({ children, showHeader = true }) => {
  const [isDesktop, setIsDesktop] = useState(
    typeof window !== 'undefined' ? window.innerWidth >= DESKTOP_MIN : true
  );
  const containerRef = useRef(null);

  useEffect(() => {
    const check = () => setIsDesktop(window.innerWidth >= DESKTOP_MIN);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  return (
    <div className="ad-container-wrapper">
      {showHeader ? <HeaderAdBanner /> : null}

      {!isDesktop && (
        <div className="mobile-ads-section">
          <MobileSponsorBanner />
        </div>
      )}

      <div className="main-content-with-ads" ref={containerRef}>
        {isDesktop && (
          <div className="left-ads-column">
            <DesktopSponsorBanner position="left" />
          </div>
        )}

        <div className="main-content">{children}</div>

        {isDesktop && (
          <div className="right-ads-column">
            <DesktopSponsorBanner position="right" />
          </div>
        )}
      </div>
    </div>
  );
};

export default AdContainer;
